// initialed state
export const initialState = () => ({
	data: {}, // { [placementId]: { [version]: { ...placementVersion } } }
});

const state = initialState();

export default state;
